import AthletesSearchForm from './AthletesSearchForm';

export default AthletesSearchForm;
